import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";

const EmailInput = ({
    email,
    setEmail,
    name,
    setName,
    lastName,
    setLastName,
    setIsVisible,
    bookPage,
    setBookPage,
    age,
    setAge,
    gender,
    setGender,
    accessToken,
}) => {
    const [loading, setLoading] = useState(false); // State to manage loading
    const [response, setResponse] = useState(null); // State to store API response
    const [errorName, setErrorName] = useState(false);
    const [errorLastName, setErrorLastName] = useState(false);
    const [errorAge, setErrorAge] = useState(false);
    const [errorGender, setErrorGender] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);

    const handleEmailInputChange = (event) => {
        setEmail(event.target.value); // Update state with input value
    };
    const handleNameInputChange = (event) => {
        setName(event.target.value); // Update state with input value
    };
    const handleLastNameInputChange = (event) => {
        setLastName(event.target.value); // Update state with input value
    };
    const handleAgeInputChange = (event) => {
        setAge(event.target.value); // Update state with input value
    };
    const handleGenderInputChange = (event) => {
        setGender(event.target.value); // Update state with input value
    };

    const fetchProfileData = async (accessToken) => {
        try {
            const response = await axios.get(
                "https://htprdapi.hightable.ai/profile-members/profile",
                {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            // console.log("Profile Data:", response.data.data);
            localStorage.setItem("@user", accessToken);
            localStorage.setItem("@userAccount", response.data.data.id);
            localStorage.setItem("@userName", response.data.data.first_name);
            localStorage.setItem("@userPhone", response.data.data.phone);
            localStorage.setItem("@userPhoto", response.data.data.photo);
            localStorage.setItem("email", response.data.data.email);
        } catch (error) {
            console.error("Failed to fetch profile data:", error);
            localStorage.removeItem("@user");
            localStorage.removeItem("@userRefreshToken");
            localStorage.removeItem("@userName");
            localStorage.removeItem("@userPhone");
            localStorage.removeItem("@userAccount");
            localStorage.removeItem("@userPhoto");
        }
    };

    const isValidEmail = (email) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const handleSubmit = async (event) => {

        event.preventDefault();
        setLoading(true);

        if (!email || !isValidEmail(email)) {
            setErrorEmail(true);
            setLoading(false);
            return;
        };
        if (!name) {
            setErrorName(true);
            setLoading(false);
            return;
        };
        if (!lastName) {
            setErrorLastName(true);
            setLoading(false);
            return;
        };
        if (!age) {
            setErrorAge(true);
            setLoading(false);
            return;
        };
        if (!gender) {
            setErrorGender(true);
            setLoading(false);
            return;
        };

        try {
            const payload = {
                email: email,
                first_name: name,
            };

            console.log("accessToken", accessToken);

            const response = await axios.put(
                "https://htprdapi.hightable.ai/profile-members/update",
                payload,
                {
                    params: { access_token: accessToken },
                    headers: { "Content-Type": "application/json" },
                }
            );

            toast.success("Profile updated successfully!", {
                position: "top-center",
            });

            if (typeof bookPage !== "undefined") {
                setBookPage(true);
                console.log("=======>bookPage", bookPage);
            };

            fetchProfileData(accessToken);
            setIsVisible(false);

        } catch (error) {
            setResponse(error.response?.data || { error: error.message });
            toast.error(error.response?.data || { error: error.message }, {
                position: "top-center",
            });
        } finally {
            setLoading(false); // Reset loading state
        }
    };

    return (
        <div className="no-margin w-form">
            <form
                onSubmit={handleSubmit}
                id="wf-form-signup"
                name="wf-form-signup"
                method="get"
                data-ms-form="signup"
                className="signup-container"
                data-wf-page-id="67499980c22f84a4749844cf"
                data-wf-element-id="8a99125d-fbbe-eda5-7895-cece5afc1721"
            >
                <a href="#" className="login-logo w-inline-block" />

                <div className="flex">

                    <div className="input-wrapper ">
                        <input
                            className={`form-field w-input rounded-l-full border ${errorName ? 'error' : ''}`}
                            placeholder={errorName ? "Enter name" : "Your Name"}
                            value={name}
                            onChange={(e) => {
                                setName(e.target.value);
                                if (errorName && e.target.value.trim() !== '') {
                                    setErrorName(false);
                                }
                            }}
                        />
                    </div>

                    <div className="input-wrapper  ml-2">
                        <input
                            className={`form-field w-input rounded-r-full ${errorLastName ? 'error' : ''}`}
                            maxLength={256}
                            name="last_name"
                            data-name="Last Name"
                            placeholder={errorLastName ? "Enter last name" : "Your Last Name"}
                            type="text"
                            id="LastName"
                            data-ms-member="last_name"
                            required
                            value={lastName}
                            onChange={(e) => {
                                setLastName(e.target.value);
                                if (errorLastName && e.target.value.trim() !== "") {
                                    setErrorLastName(false);
                                }
                            }}
                        />
                    </div>
                </div>

                <div className="input-wrapper">
                    <input
                        className={`form-field w-input border-radius-50 ${
                            // if no email enter error message should be in red color
                            errorEmail ? `error` : `border-gray-300`
                            }`}
                        maxLength={256}
                        name="email"
                        data-name="Email"
                        placeholder={errorEmail ? "Enter valid email" : "Email Address"}
                        type="email"
                        id="Email"
                        data-ms-member="email"
                        required
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            if (errorEmail && e.target.value.trim() !== "") {
                                setErrorEmail(false);
                            }
                        }}
                    />
                </div>

                <div className="flex">
                    <div className="input-wrapper">
                        <input
                            className={`form-field w-input rounded-l-full ${errorAge ? 'error' : ''}`}
                            maxLength={256}
                            name="age"
                            data-name="Age"
                            placeholder={errorAge ? "Enter age" : "Age"}
                            type="number"
                            id="Age"
                            data-ms-member="age"
                            required
                            value={age}
                            onChange={(e) => {
                                setAge(e.target.value);
                                if (errorAge && e.target.value.trim() !== "") {
                                    setErrorAge(false);
                                }
                            }}
                        />
                    </div >

                    <div className="input-wrapper  ml-2">
                        <input
                            className={`form-field w-input rounded-r-full ${errorGender ? 'error' : ''}`}
                            maxLength={256}
                            name="gender"
                            data-name="Gender"
                            placeholder={errorGender ? "Enter gender" : "Gender"}
                            type="text"
                            id="Gender"
                            data-ms-member="gender"
                            required
                            value={gender}
                            onChange={(e) => {
                                setGender(e.target.value);
                                if (errorGender && e.target.value.trim() !== "") {
                                    setErrorGender(false);
                                }
                            }}
                        />
                    </div>
                </div>

                <input
                    type="submit"
                    data-wait="Please wait..."
                    className="button-4 w-button"
                    defaultValue="Submit"
                    onClick={handleSubmit}
                />
            </form>
        </div>
    );

};

export default EmailInput;
